import { useState, useCallback, useEffect } from 'react'
import { CrmTeamMember, TeamMemberInput, listTeamMembers, createTeamMember, updateTeamMember, deleteTeamMember } from 'api/oracleApi'

export function useTeamMembers() {
    const [members, setMembers] = useState<CrmTeamMember[]>([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const fetch = useCallback(async () => {
        setLoading(true)
        setError('')
        try {
            const data = await listTeamMembers()
            setMembers(data)
        } catch {
            setError('Failed to load team members')
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        fetch()
    }, [fetch])

    const create = useCallback(
        async (input: TeamMemberInput) => {
            await createTeamMember(input)
            await fetch()
        },
        [fetch]
    )

    const update = useCallback(
        async (id: string, input: Partial<TeamMemberInput>) => {
            await updateTeamMember(id, input)
            await fetch()
        },
        [fetch]
    )

    const remove = useCallback(
        async (id: string) => {
            await deleteTeamMember(id)
            await fetch()
        },
        [fetch]
    )

    return { members, loading, error, refetch: fetch, create, update, remove }
}
